import * as Tooltip from '@radix-ui/react-tooltip';
import { ReactNode } from 'react';
import './styles.css';

interface PhaseTooltipProps {
  title: ReactNode;
  description: string;
  isDisabled?: boolean;
  children?: ReactNode;
}

export function PhaseTooltip({
  title,
  description,
  isDisabled,
  children,
}: PhaseTooltipProps) {
  if (isDisabled) return <>{children}</>;

  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content side="bottom" sideOffset={19.5} asChild>
            <div className="phase-page-tooltip">
              <div className="phase-page-tooltip--title">{title}</div>
              <div className="phase-page-tooltip--description">
                {description}
              </div>
            </div>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
